function initRegisterForm() {

  $(document).on('click', '#sh-mav-share-btn', function () {
    const tempInput = $('<input>');
    $('body').append(tempInput);
    tempInput.val(window.location.href).select();
    document.execCommand('copy');
    tempInput.remove();
    $('.sh-mav-share-txt-confirm').show();
  });

  $(document).on('click', '#sh-mav-register', function () {
    const email = $('#mav_email').val();
    const first_name = $('#mav_first_name').val();
    const last_name = $('#mav_last_name').val();

    $('.sh-mav-input-wrap').removeClass('error');

    const emailReg = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    if (!email || !emailReg.test(email)) {
      $('#mav_email').parent().addClass('error');
      return;
    }


    if (!first_name) {
      $('#mav_first_name').parent().addClass('error');
      return;
    }

    if (!last_name) {
      $('#mav_last_name').parent().addClass('error');
      return;
    }
    const mavId = $('#webinar_id').val();

    $('.sh-mav-registration-form').hide();
    $('.sh-mav-btn-registering').show();
    $.ajax({
      url: `${window.ajax.api_host}/api/public/v1/mav/${mavId}/register`,
      type: 'post',
      dataType: 'json',
      data: {
        email: email,
        firstName: first_name,
        lastName: last_name,
      },
      headers: {
        'Client-ID': window.ajax.api_client_id,
        'Client-Secret': window.ajax.api_client_secret,
      },
      error() {
        $('.sh-mav-registration-form').hide();
        $('.sh-mav-btn-registering').hide();
        $('.sh-mav-register-success').hide();
        $('.sh-mav-register-error').show();
      },
      success: function () {
        $('.sh-mav-registration-form').hide();
        $('.sh-mav-btn-registering').hide();
        $('.sh-mav-register-success').show();
      },
    });
  });

}

export default {
  init() {
    initRegisterForm();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
